// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_eb-2";
export var aiChatCartContainerExit = "_eb-4";
export var aiChatContainerLarge = "_eb-0";
export var aiChatContainerSmall = "_eb-1";
export var aiChatIcon = "_eb-6";
export var slideInFromRight = "_eb-3";
export var slideOutToRight = "_eb-5";